
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M4.375 5.977 1.73 8.5m0 0 2.645 2.523M1.73 8.5H15"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M7.987 4.346h6.91M7.987 12.346h6.91"}})])
          )
        }
      }
    